// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"layoutWrapper--2JIlr","mainWrapper":"mainWrapper--QnQ8B","collapsed":"collapsed--X1xN6","contentWrapper":"contentWrapper--KDExb","sider":"sider--HqY6y"};